module.exports = __webpack_public_path__ + "img/LV40003072918.89aa4440.png";